import { useTranslation } from "react-i18next";

import { TableHeader } from "@/components/Layout/Table/TableHeader/TableHeader";
import { TableSortButton } from "@/components/Layout/Table/TableSortButton/TableSortButton";
import { BillSelectAllCheckbox } from "@/components/Portal/Documents/BillList/components/BillSelectAllCheckbox/BillSelectAllCheckbox";

const enum availableSortFields {
  DATE = "Datum",
  NAME = "Abrechnungsmonat",
  NUMBER = "Rechnungsnummer",
  AMOUNT = "Betrag",
  STATUS = "Status",
}

// this is the table header row for the invoices list
export const BillListHeader = ({
  currentPageBillIds,
  isSelecting,
}: {
  currentPageBillIds: number[];
  isSelecting?: boolean;
}) => {
  const { t } = useTranslation("portal");

  return (
    <TableHeader>
      <th>
        <TableSortButton
          title={t("bills.list.tableHeaders.date")}
          sortField={availableSortFields.DATE}
        />
      </th>
      <th>
        <TableSortButton
          title={t("bills.list.tableHeaders.invoiceFor")}
          sortField={availableSortFields.NAME}
        />
      </th>
      <th>
        <TableSortButton
          title={t("bills.list.tableHeaders.number")}
          sortField={availableSortFields.NUMBER}
        />
      </th>
      <th>
        <TableSortButton
          title={t("bills.list.tableHeaders.amount")}
          sortField={availableSortFields.AMOUNT}
        />
      </th>
      <th>
        <TableSortButton
          title={t("bills.list.tableHeaders.status")}
          sortField={availableSortFields.STATUS}
        />
      </th>
      {/* The trailing column swaps per state: the checkbox column takes the
          place of "Öffnen" while selecting, so the five data columns keep
          sharing the remaining width evenly. */}
      {isSelecting ? (
        <th className="bill-selection">
          <BillSelectAllCheckbox currentPageBillIds={currentPageBillIds} />
        </th>
      ) : (
        <th>{t("bills.list.tableHeaders.open")}</th>
      )}
    </TableHeader>
  );
};
